<template>
	<div class="wrapper">
		<div v-if="state === 'processing'" />
	</div>
</template>
<script>
export default {
	$pubsub: {},
	watch: {
		state: {
			immediate: true,
			handler(newVal, oldVal) {
				if (!this.ignore) {
					if (newVal !== oldVal) {
						this.$emit("triggerReCalc");
					}
				}
				this.ignore = false;
			}
		}
	},
	data() {
		return {
			ignore: true
		}
	},
	props: {
		ORO: {
			required: true
		}
	},
	computed: {
		state() {
			return this.ORO.state;
		}
	}
}
</script>
<style lang="scss" scoped>
div.wrapper {
	display: none;
}
</style>